import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolTcListPage(app: HTMLElement): Promise<void> {
  const terminationTable = 'termination_table_others';
  const studentTable = 'student_database_others';
  const currentUser = localStorage.getItem('adminButton') || 'admin';

  app.innerHTML = `
    <style>
      .tc-wrap {
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.02), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        color: #334155;
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        min-height: 100vh;
        padding-bottom: 40px;
      }
      .tc-header {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        padding: 16px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .tc-header h1 {
        font-size: 20px;
        margin: 0;
        font-weight: 800;
        color: #0f172a;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .back-btn {
        color: #10b981;
        text-decoration: none;
        margin-right: 12px;
        font-size: 20px;
        font-weight: bold;
        transition: transform 0.2s;
        display: inline-block;
      }
      .back-btn:hover {
        transform: translateX(-3px);
      }
      .tc-container {
        padding: 24px;
        max-width: 1200px;
        margin: 0 auto;
      }
      .info-banner {
        background: rgba(245, 158, 11, 0.06);
        border: 1px solid rgba(245, 158, 11, 0.2);
        color: #d97706;
        padding: 12px 16px;
        border-radius: 10px;
        font-size: 13px;
        line-height: 1.4;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .toolbar {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        background: rgba(255, 255, 255, 0.8);
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 16px;
        box-shadow: 0 4px 15px rgba(0,0,0,0.02);
      }
      .search-box {
        position: relative;
        flex: 1;
        min-width: 280px;
      }
      .search-box input {
        width: 100%;
        padding: 10px 16px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        color: #0f172a;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s;
      }
      .search-box input:focus {
        border-color: #10b981;
      }
      .actions-group {
        display: flex;
        gap: 16px;
        align-items: center;
      }
      .primary-btn {
        background: linear-gradient(135deg, #10b981, #059669);
        color: #ffffff;
        border: none;
        border-radius: 8px;
        padding: 10px 20px;
        font-size: 13px;
        font-weight: 700;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
      }
      .primary-btn:hover {
        opacity: 0.95;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
      }
      .secondary-btn {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
        border-radius: 8px;
        padding: 10px 16px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s;
      }
      .secondary-btn:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .table-card {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.03);
        overflow: hidden;
      }
      .tc-table {
        width: 100%;
        border-collapse: collapse;
        text-align: left;
      }
      .tc-table th {
        background: rgba(248, 250, 252, 0.9);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        padding: 14px 16px;
        font-size: 13px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .tc-table td {
        padding: 12px 16px;
        font-size: 14px;
        color: #334155;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      }
      .tc-table tbody tr:hover {
        background: rgba(0, 0, 0, 0.01);
      }
      .status-badge {
        font-size: 10px;
        font-weight: 800;
        text-transform: uppercase;
        padding: 3px 8px;
        border-radius: 12px;
        letter-spacing: 0.05em;
      }
      .status-loaded {
        background: rgba(16, 185, 129, 0.08);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.2);
      }
      .action-link {
        color: #10b981;
        text-decoration: none;
        font-weight: 700;
        transition: color 0.2s;
      }
      .action-link:hover {
        color: #059669;
        text-decoration: underline;
      }
      .sep {
        color: rgba(0, 0, 0, 0.15);
        margin: 0 8px;
      }
      .count-badge {
        background: rgba(16, 185, 129, 0.1);
        color: #059669;
        padding: 2px 8px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 700;
      }

      /* Modal styling */
      .modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.4);
        backdrop-filter: blur(4px);
        display: none;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        padding: 20px;
      }
      .modal-card {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        width: 100%;
        max-width: 680px;
        box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1);
        overflow: hidden;
        animation: modalFadeIn 0.3s ease-out;
      }
      @keyframes modalFadeIn {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .modal-header {
        padding: 18px 24px;
        background: rgba(248, 250, 252, 0.95);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .modal-header h2 {
        font-size: 16px;
        font-weight: 800;
        margin: 0;
        color: #0f172a;
      }
      .close-btn {
        background: rgba(0, 0, 0, 0.04);
        border: 1px solid rgba(0, 0, 0, 0.08);
        color: #64748b;
        border-radius: 6px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 12px;
        transition: all 0.2s;
      }
      .close-btn:hover {
        background: rgba(239, 68, 68, 0.1);
        color: #ef4444;
        border-color: rgba(239, 68, 68, 0.2);
      }
      .modal-body {
        padding: 24px;
        max-height: 75vh;
        overflow-y: auto;
      }
      .grid-layout {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 16px;
      }
      .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .form-group.full-width {
        grid-column: 1 / -1;
      }
      .form-group label {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .form-group input, .form-group select, .form-group textarea {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        color: #0f172a;
        padding: 10px 12px;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
        border-color: #10b981;
        box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
      }
      .form-group input[readonly] {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.06);
        color: #64748b;
        cursor: not-allowed;
      }
      .modal-footer {
        padding: 18px 24px;
        background: rgba(248, 250, 252, 0.95);
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        display: flex;
        gap: 12px;
        justify-content: flex-end;
      }
      .load-btn {
        background: #2563eb;
        color: white;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        font-weight: bold;
        cursor: pointer;
        font-size: 13px;
        transition: opacity 0.2s;
      }
      .load-btn:hover {
        opacity: 0.9;
      }
    </style>

    <div class="tc-wrap">
      <div class="tc-header">
        <h1>
          <a href="/other_school_dashboard" class="back-btn">←</a>
          Transfer Certificate List (Other School)
          <span class="status-badge status-loaded" id="status">Loading...</span>
        </h1>
        <div style="font-size: 13px; color: #64748b; font-weight: 600;">
          User: <span style="color: #10b981;">${escapeHtml(currentUser)}</span>
        </div>
      </div>

      <div class="tc-container">
        <div class="info-banner">
          <span>⚠️</span>
          <span>TC এন্ট্রিকরার সাথে সাথে এন্টি হয়ে যাবে। তাই সাবধাণতা অবলম্বণ করুণ। Word button দিয়ে সার্টিফিকেট প্রিন্ট বা ডাউনলোড করুন।</span>
        </div>

        <div class="toolbar">
          <div class="search-box">
            <input type="text" id="searchInput" placeholder="Filter by Name, Class, Roll, IID..." />
          </div>
          <div class="actions-group">
            <span style="font-size: 13px; color: #64748b; font-weight: 600;">
              Total: <span class="count-badge" id="countVal">0</span>
            </span>
            <button id="openModalBtn" class="primary-btn">
              <span>➕</span> New TC Entry
            </button>
          </div>
        </div>

        <div class="table-card">
          <table class="tc-table">
            <thead>
              <tr>
                <th>TC Serial</th>
                <th>Name</th>
                <th>Father</th>
                <th>Class</th>
                <th>Roll</th>
                <th>IID</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody id="tcTableBody">
              <tr>
                <td colspan="7" style="text-align: center; color: #64748b; padding: 24px;">Loading Transfer Certificate records...</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- TC Entry Modal -->
    <div class="modal-overlay" id="tcModal">
      <div class="modal-card">
        <div class="modal-header">
          <h2>New Transfer Certificate Entry</h2>
          <button class="close-btn" id="closeModalBtn">✕</button>
        </div>
        <form id="tcEntryForm">
          <div class="modal-body">
            <div style="margin-bottom: 18px; padding: 10px 14px; background: rgba(16, 185, 129, 0.05); border: 1px solid rgba(16, 185, 129, 0.15); border-radius: 8px; font-size: 12px; color: #059669;" id="modalStatusMsg">
              Enter IID and click 'Load' to retrieve student data.
            </div>

            <div class="grid-layout">
              <div class="form-group">
                <label>Student IID *</label>
                <div style="display: flex; gap: 8px;">
                  <input type="text" id="iidInput" name="iid" required placeholder="e.g. 10025" style="flex: 1;" />
                  <button type="button" class="load-btn" id="loadStudentBtn">Load</button>
                </div>
              </div>
              <div class="form-group">
                <label>Session</label>
                <input type="text" id="tc_session" name="tc_session" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Class</label>
                <input type="text" id="tc_class" name="tc_class" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Section</label>
                <input type="text" id="tc_section" name="tc_section" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Roll</label>
                <input type="text" id="tc_roll" name="tc_roll" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Student Name</label>
                <input type="text" id="student_name_en" name="student_name_en" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Father's Name</label>
                <input type="text" id="father_name_en" name="father_name_en" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Mother's Name</label>
                <input type="text" id="mother_name_en" name="mother_name_en" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Date of Birth</label>
                <input type="text" id="student_dateofbirth" name="student_dateofbirth" readonly placeholder="Auto-filled" />
              </div>
              <div class="form-group">
                <label>Gender</label>
                <input type="text" id="student_gender" name="student_gender" readonly placeholder="Auto-filled" />
              </div>

              <!-- Editable Section -->
              <div class="form-group">
                <label>Paid Upto *</label>
                <select id="paid_month" name="paid_month" required>
                  <option value="December 2025">December 2025</option>
                </select>
              </div>
              <div class="form-group">
                <label>Character *</label>
                <select id="student_character" name="student_character" required>
                  <option value="very good">very good</option>
                  <option value="good">good</option>
                  <option value="bad">bad</option>
                  <option value="very bad">very bad</option>
                </select>
              </div>
              <div class="form-group">
                <label>Next Class *</label>
                <select id="next_class" name="next_class" required>
                  <option value=""></option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
              </div>
              <div class="form-group">
                <label>TC Issue Date *</label>
                <input type="text" id="tc_date" name="tc_date" required placeholder="DD-MM-YYYY" />
              </div>
              <div class="form-group">
                <label>Issued By *</label>
                <select id="issued_by" name="issued_by" required>
                  <option value="RAZIB KUMAR PAUL">RAZIB KUMAR PAUL</option>
                  <option value="SHOWRAV DEB">SHOWRAV DEB</option>
                </select>
              </div>
              <div class="form-group">
                <label>Father's Mobile</label>
                <input type="text" id="father_mobile" name="father_mobile" placeholder="Mobile prefix 880" />
              </div>
              <div class="form-group full-width">
                <label>Note / Remarks</label>
                <textarea id="note" name="note" placeholder="Add any special remarks or reasons..." rows="3"></textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="secondary-btn" id="resetModalBtn">Reset Form</button>
            <button type="submit" class="primary-btn" style="background: linear-gradient(135deg, #10b981, #059669);" id="saveTcBtn" disabled>Save TC Record</button>
          </div>
        </form>
      </div>
    </div>
  `;

  // DOM Elements
  const statusBadge = document.getElementById('status')!;
  const countVal = document.getElementById('countVal')!;
  const tcTableBody = document.getElementById('tcTableBody')!;
  const searchInput = document.getElementById('searchInput') as HTMLInputElement;

  const modal = document.getElementById('tcModal')!;
  const openModalBtn = document.getElementById('openModalBtn')!;
  const closeModalBtn = document.getElementById('closeModalBtn')!;
  const resetModalBtn = document.getElementById('resetModalBtn')!;
  const tcEntryForm = document.getElementById('tcEntryForm') as HTMLFormElement;
  
  const iidInput = document.getElementById('iidInput') as HTMLInputElement;
  const loadStudentBtn = document.getElementById('loadStudentBtn') as HTMLButtonElement;
  const modalStatusMsg = document.getElementById('modalStatusMsg')!;
  const saveTcBtn = document.getElementById('saveTcBtn') as HTMLButtonElement;

  // Auto-filled fields in modal
  const modalFields = {
    tc_session: document.getElementById('tc_session') as HTMLInputElement,
    tc_class: document.getElementById('tc_class') as HTMLInputElement,
    tc_section: document.getElementById('tc_section') as HTMLInputElement,
    tc_roll: document.getElementById('tc_roll') as HTMLInputElement,
    student_name_en: document.getElementById('student_name_en') as HTMLInputElement,
    father_name_en: document.getElementById('father_name_en') as HTMLInputElement,
    mother_name_en: document.getElementById('mother_name_en') as HTMLInputElement,
    student_dateofbirth: document.getElementById('student_dateofbirth') as HTMLInputElement,
    student_gender: document.getElementById('student_gender') as HTMLInputElement,
    father_mobile: document.getElementById('father_mobile') as HTMLInputElement,
  };

  let allRecords: any[] = [];

  // Initialize helper options
  function initOptions() {
    // Generate Paid Month Options
    const paidMonthSel = document.getElementById('paid_month') as HTMLSelectElement;
    if (paidMonthSel) {
      paidMonthSel.innerHTML = '';
      const years = [2025, 2026, 2027];
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      for (const y of years) {
        for (const m of months) {
          const opt = document.createElement('option');
          opt.value = `${m} ${y}`;
          opt.textContent = `${m} ${y}`;
          paidMonthSel.appendChild(opt);
        }
      }
      paidMonthSel.value = 'December 2025';
    }

    // Set Default TC Date to today (DD-MM-YYYY)
    const tcDateInput = document.getElementById('tc_date') as HTMLInputElement;
    if (tcDateInput) {
      const d = new Date();
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      tcDateInput.value = `${dd}-${mm}-${yyyy}`;
    }
  }

  // Fetch TC Records
  async function loadTcRecords() {
    statusBadge.textContent = 'Loading...';
    try {
      // 1. Fetch from termination_table_others
      const { data: tcData, error: tcError } = await sb.from(terminationTable)
        .select('*');

      if (tcError) throw tcError;

      // 2. Fetch from student_database_others where status = 'TC'
      const { data: studentData, error: studentError } = await sb.from('student_database_others')
        .select('*')
        .eq('status', 'TC');

      if (studentError) throw studentError;

      const tcList = tcData || [];
      const tcIids = new Set(tcList.map(r => Number(r.iid)));

      // Merge virtual records from student_database_others
      const mergedList = [...tcList];
      if (studentData) {
        for (const stu of studentData) {
          const stuIid = Number(stu.iid);
          if (!tcIids.has(stuIid)) {
            const session = stu.session || 2025;
            mergedList.push({
              tc_sl: stu.tc_no ? parseInt(stu.tc_no, 10) : null,
              student_name_en: stu.student_name_en || stu.name_en || '',
              father_name_en: stu.father_name_en || '',
              tc_class: stu[`class_${session}`] || stu.class || '',
              tc_roll: stu[`roll_${session}`] || stu.roll || '',
              iid: stu.iid,
              tc_date: stu.tc_date || '',
              note: stu.comment_school || '',
              isVirtual: true
            });
          }
        }
      }

      // Sort by tc_sl descending
      mergedList.sort((a, b) => {
        const slA = a.tc_sl ? Number(a.tc_sl) : 0;
        const slB = b.tc_sl ? Number(b.tc_sl) : 0;
        return slB - slA;
      });

      allRecords = mergedList;
      renderRecords(allRecords);
      statusBadge.textContent = 'Loaded';
    } catch (e: any) {
      console.error(e);
      statusBadge.textContent = 'Error';
      tcTableBody.innerHTML = `
        <tr>
          <td colspan="7" style="text-align: center; color: #dc2626; padding: 24px; font-weight: 700;">
            Failed to load records. Please retry.
          </td>
        </tr>
      `;
    }
  }

  // Render TC Records to Table
  function renderRecords(records: any[]) {
    countVal.textContent = String(records.length);
    if (!records.length) {
      tcTableBody.innerHTML = `
        <tr>
          <td colspan="7" style="text-align: center; color: #64748b; padding: 24px;">No Transfer Certificate records found.</td>
        </tr>
      `;
      return;
    }

    tcTableBody.innerHTML = records.map(rec => `
      <tr>
        <td style="font-weight: 700; color: #059669;">${escapeHtml(String(rec.tc_sl ?? '-'))}</td>
        <td style="font-weight: 600; color: #0f172a;">${escapeHtml(String(rec.student_name_en ?? ''))}</td>
        <td>${escapeHtml(String(rec.father_name_en ?? ''))}</td>
        <td><span class="status-badge" style="background: rgba(37, 99, 235, 0.05); color: #2563eb; border: 1px solid rgba(37, 99, 235, 0.15);">Class ${escapeHtml(String(rec.tc_class ?? ''))}</span></td>
        <td style="font-weight: 700; color: #334155;">${escapeHtml(String(rec.tc_roll ?? ''))}</td>
        <td>
          <a href="/other_school/edit_details?iid=${encodeURIComponent(String(rec.iid))}" class="action-link" style="color: #2563eb;">${escapeHtml(String(rec.iid ?? ''))}</a>
        </td>
        <td>
          <a href="/other_school/tc/tc_edit_form?iid=${encodeURIComponent(String(rec.iid))}" class="action-link">Edit</a>
          <span class="sep">|</span>
          <a href="/other_school/tc/certificate_word?iid=${encodeURIComponent(String(rec.iid))}" target="_blank" class="action-link" style="color: #d97706;">Certificate</a>
        </td>
      </tr>
    `).join('');
  }

  // Filtering Search
  searchInput.addEventListener('input', () => {
    const q = searchInput.value.toLowerCase().trim();
    if (!q) {
      renderRecords(allRecords);
      return;
    }
    const filtered = allRecords.filter(rec => 
      String(rec.student_name_en || '').toLowerCase().includes(q) ||
      String(rec.father_name_en || '').toLowerCase().includes(q) ||
      String(rec.tc_class || '').toLowerCase().includes(q) ||
      String(rec.tc_roll || '').toLowerCase().includes(q) ||
      String(rec.iid || '').toLowerCase().includes(q) ||
      String(rec.tc_sl || '').toLowerCase().includes(q)
    );
    renderRecords(filtered);
  });

  // Modal Open/Close Actions
  openModalBtn.onclick = () => {
    modal.style.display = 'flex';
    resetModalForm();
    modalStatusMsg.innerHTML = "Enter IID and click 'Load' to retrieve student data.";
    modalStatusMsg.style.background = 'rgba(16, 185, 129, 0.05)';
    modalStatusMsg.style.borderColor = 'rgba(16, 185, 129, 0.15)';
    modalStatusMsg.style.color = '#059669';
    iidInput.focus();
  };

  const closeModal = () => {
    modal.style.display = 'none';
    tcEntryForm.reset();
  };

  closeModalBtn.onclick = closeModal;
  modal.onclick = (e) => {
    if (e.target === modal) closeModal();
  };

  function setReadonly(readonly: boolean) {
    for (const key of Object.keys(modalFields)) {
      if (key !== 'father_mobile') {
        const field = modalFields[key as keyof typeof modalFields];
        if (field) field.readOnly = readonly;
      }
    }
  }

  // Clear Fields
  function clearFields() {
    for (const key of Object.keys(modalFields)) {
      const field = modalFields[key as keyof typeof modalFields];
      if (field) field.value = '';
    }
    saveTcBtn.disabled = true;
  }

  function resetModalForm() {
    tcEntryForm.reset();
    clearFields();
    setReadonly(true);
    initOptions();
  }

  resetModalBtn.onclick = resetModalForm;

  // Load Student Info from IID
  async function loadStudentData() {
    const iid = iidInput.value.trim();
    if (!iid) {
      modalStatusMsg.textContent = 'Please enter a valid Student IID.';
      modalStatusMsg.style.background = 'rgba(239, 68, 68, 0.05)';
      modalStatusMsg.style.borderColor = 'rgba(239, 68, 68, 0.15)';
      modalStatusMsg.style.color = '#dc2626';
      return;
    }

    modalStatusMsg.textContent = 'Querying student database...';
    modalStatusMsg.style.background = 'rgba(59, 130, 246, 0.05)';
    modalStatusMsg.style.borderColor = 'rgba(59, 130, 246, 0.15)';
    modalStatusMsg.style.color = '#2563eb';
    clearFields();
    setReadonly(true);

    try {
      const { data, error } = await sb.from(studentTable)
        .select('*')
        .eq('iid', iid)
        .limit(1);

      if (error) throw error;
      if (!data || !data.length) {
        modalStatusMsg.textContent = `Student with IID '${iid}' not found.`;
        modalStatusMsg.style.background = 'rgba(239, 68, 68, 0.05)';
        modalStatusMsg.style.borderColor = 'rgba(239, 68, 68, 0.15)';
        modalStatusMsg.style.color = '#dc2626';
        return;
      }

      const stu = data[0];
      const session = stu.session || '';
      
      // Auto-fill core fields
      modalFields.tc_session.value = session;
      modalFields.tc_class.value = stu[`class_${session}`] || stu.class || '';
      modalFields.tc_section.value = stu[`section_${session}`] || stu.section || '';
      modalFields.tc_roll.value = stu[`roll_${session}`] || stu.roll || '';
      modalFields.student_name_en.value = stu.student_name_en || stu.name_en || stu.name || '';
      modalFields.father_name_en.value = stu.father_name_en || stu.father || '';
      modalFields.mother_name_en.value = stu.mother_name_en || stu.mother || '';
      modalFields.student_dateofbirth.value = stu.student_dateofbirth || stu.dob || '';
      modalFields.student_gender.value = stu.student_gender || stu.gender || '';
      modalFields.father_mobile.value = stu.father_mobile || stu.guardian_mobile || '';

      // Activate for editing/save
      setReadonly(false);
      saveTcBtn.disabled = false;
      modalStatusMsg.textContent = 'Student data loaded successfully! Review the details and submit.';
      modalStatusMsg.style.background = 'rgba(16, 185, 129, 0.05)';
      modalStatusMsg.style.borderColor = 'rgba(16, 185, 129, 0.15)';
      modalStatusMsg.style.color = '#059669';
    } catch (e: any) {
      console.error(e);
      modalStatusMsg.textContent = 'Database query failed. Try again.';
      modalStatusMsg.style.background = 'rgba(239, 68, 68, 0.05)';
      modalStatusMsg.style.borderColor = 'rgba(239, 68, 68, 0.15)';
      modalStatusMsg.style.color = '#dc2626';
    }
  }

  loadStudentBtn.onclick = loadStudentData;
  iidInput.onkeydown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      loadStudentData();
    }
  };

  // Submit Entry Form
  tcEntryForm.onsubmit = async (e) => {
    e.preventDefault();
    saveTcBtn.disabled = true;
    modalStatusMsg.textContent = 'Saving Transfer Certificate record...';
    modalStatusMsg.style.color = '#2563eb';

    const payload = {
      iid: iidInput.value.trim(),
      tc_session: modalFields.tc_session.value.trim(),
      tc_class: modalFields.tc_class.value.trim(),
      tc_section: modalFields.tc_section.value.trim(),
      tc_roll: modalFields.tc_roll.value.trim(),
      student_name_en: modalFields.student_name_en.value.trim(),
      father_name_en: modalFields.father_name_en.value.trim(),
      mother_name_en: modalFields.mother_name_en.value.trim(),
      student_dateofbirth: modalFields.student_dateofbirth.value.trim(),
      student_gender: modalFields.student_gender.value.trim(),
      paid_month: (document.getElementById('paid_month') as HTMLSelectElement).value,
      student_character: (document.getElementById('student_character') as HTMLSelectElement).value,
      next_class: (document.getElementById('next_class') as HTMLSelectElement).value,
      tc_date: (document.getElementById('tc_date') as HTMLInputElement).value.trim(),
      issued_by: (document.getElementById('issued_by') as HTMLSelectElement).value,
      father_mobile: modalFields.father_mobile.value.trim(),
      note: (document.getElementById('note') as HTMLTextAreaElement).value.trim()
    };

    // Mobile Prefix 880 validation rule
    if (payload.father_mobile && !payload.father_mobile.startsWith('880')) {
      alert("Mobile number must start with the country code '880'.");
      modalStatusMsg.textContent = "Validation Failed: Father's Mobile must start with '880'.";
      modalStatusMsg.style.color = '#dc2626';
      saveTcBtn.disabled = false;
      return;
    }

    try {
      // 1. Check if TC already issued for this Student IID
      const { data: existing, error: existErr } = await sb.from(terminationTable)
        .select('iid')
        .eq('iid', payload.iid)
        .limit(1);

      if (existErr) throw existErr;
      if (existing && existing.length) {
        modalStatusMsg.textContent = `A Transfer Certificate has already been issued for IID '${payload.iid}'.`;
        modalStatusMsg.style.background = 'rgba(239, 68, 68, 0.05)';
        modalStatusMsg.style.borderColor = 'rgba(239, 68, 68, 0.15)';
        modalStatusMsg.style.color = '#dc2626';
        saveTcBtn.disabled = false;
        return;
      }

      // 2. Insert into termination_table_others
      const { data: inserted, error: insertErr } = await sb.from(terminationTable)
        .insert(payload)
        .select('tc_sl, tc_date, iid')
        .single();

      if (insertErr) throw insertErr;

      // 3. Update main student_database_others: status='TC', tc_date, and tc_no=tc_sl
      if (inserted) {
        const studentUpdate = {
          status: 'TC',
          tc_date: inserted.tc_date || payload.tc_date || null,
          tc_no: inserted.tc_sl || null
        };

        const { error: updateErr } = await sb.from(studentTable)
          .update(studentUpdate)
          .eq('iid', payload.iid);

        if (updateErr) {
          console.warn('Student profile status update failed, but TC record saved.', updateErr);
        }
      }

      modalStatusMsg.textContent = 'TC Record successfully issued! Closing modal...';
      modalStatusMsg.style.background = 'rgba(16, 185, 129, 0.05)';
      modalStatusMsg.style.borderColor = 'rgba(16, 185, 129, 0.15)';
      modalStatusMsg.style.color = '#059669';

      setTimeout(() => {
        closeModal();
        loadTcRecords(); // reload table records
      }, 1000);
    } catch (e: any) {
      console.error(e);
      modalStatusMsg.textContent = 'Failed to save TC. Please check inputs and retry.';
      modalStatusMsg.style.background = 'rgba(239, 68, 68, 0.05)';
      modalStatusMsg.style.borderColor = 'rgba(239, 68, 68, 0.15)';
      modalStatusMsg.style.color = '#dc2626';
      saveTcBtn.disabled = false;
    }
  };

  // Perform Initial Loadings
  initOptions();
  await loadTcRecords();
}
